import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ErrorBoundary } from '@sentry/react'

import CenteredLayout from '$layouts/CenteredLayout'

import { retryAsync } from '$app/utilities'

import App from '$app/App'

import '@trustycars/genie-ui/style/global'
import '$styles/themes/attach.css'
import '$styles/global'

import '$app/states/initialize'

retryAsync(() => import('@sentry/browser')).then(
  ({
    init,
    browserTracingIntegration,
    browserProfilingIntegration,
    replayIntegration
  }) => {
    init({
      enabled: import.meta.env.PROD,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
      integrations: [
        browserTracingIntegration(),
        replayIntegration(),
        browserProfilingIntegration()
      ],
      tracesSampleRate: import.meta.env.DEV ? 1 : 0.1,
      replaysSessionSampleRate: import.meta.env.DEV ? 1 : 0.1
    })
  }
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary
      showDialog
      fallback={
        <CenteredLayout>
          The application has stopped working. Please get in touch with the
          administrators.
        </CenteredLayout>
      }
    >
      <App />
    </ErrorBoundary>
  </StrictMode>
)
